import { Controller } from "@hotwired/stimulus";

/**
 * remodal の open/close を CustomEvent として外部へ通知する controller。
 *
 * 対象DOM:
 * - remodal を初期化している要素に `data-controller` を付ける
 *
 * 発火イベント:
 * - "open": remodal の opening フックで dispatch
 * - "close": remodal の closed フックで dispatch
 */
export default class extends Controller {
  initialize() {
    const openEvent = new CustomEvent("open", {});
    const closeEvent = new CustomEvent("close", {});

    $(this.element).on("opening", this.dispatchEvent.bind(this, openEvent));
    $(this.element).on("closed", this.dispatchEvent.bind(this, closeEvent));
  }

  disconnect() {
    $(this.element).off("opening", this.dispatchEvent);
    $(this.element).off("closed", this.dispatchEvent);
  }

  dispatchEvent(customEvent) {
    this.element.dispatchEvent(customEvent);
  }
}
